import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import Routers from './routes'

import 'react-toastify/dist/ReactToastify.css'
import './App.css'

function App() {
  return (
    <>
      <BrowserRouter>
        <Routers />
      </BrowserRouter>
      <ToastContainer />
    </>
  )
}

export default App
